import { useCallback, useState } from "react";

const useIncrement = (initialValue = 0): [number, () => void] => {
  const [value, setValue] = useState<number>(initialValue);
  const onIncrement = useCallback(() => setValue(current => current + 1), [setValue]);

  return [value, onIncrement];
};

export default useIncrement;
